import algoliasearch from 'algoliasearch/lite'
import Env from '../env'

// Create a singleton Algolia client that can be imported by components
const algoliaInstance = Env.algolia()
let searchClient = null

if (algoliaInstance) {
  const { appId, token: apiKey } = algoliaInstance
  searchClient = algoliasearch(appId, apiKey)
}

export default searchClient
